import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { Loading } from "@website/ui/loading";
import { getOrigin } from "@website/utils/channel/get-origin";
import { Banner, BannerPropertiesType } from "@website/widget/banner";
import { GetServerSideProps } from "next";
const Index = () => {
  const {
    data,
    isLoading
  }: { data: BannerPropertiesType; isLoading: boolean } = useFetcher({
    queryKey: ["flight_takeoff_external_widget"],
    queryFn: () =>
      fetcher({
        url: `${process.env.NEXT_PUBLIC_BASE_URL_API}/api/price-table/external-widget`,
        method: "GET"
      }).then((data) => ({
        icon: "flight_takeoff",
        title: "خرید بلیط پرواز خارجی",
        link: `${getOrigin()}/inter-flights`,
        items: Array.isArray(data?.data)
          ? data.data.map((item) => ({
              icon: "flight",
              title: item.title,
              price: item.price / 10,
              currency: "تومان",
              link: item.url
            }))
          : []
      }))
  });
  if (isLoading) {
    return (
      <div className="flex w-screen justify-center py-2">
        <Loading />
      </div>
    );
  }
  if (!data?.items?.length) {
    return null;
  }
  return <Banner {...data} />;
};
export default Index;

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.setHeader(
    "Cache-Control",
    "s-maxage=900, stale-while-revalidate=31535700"
  );
  return {
    props: {}
  };
};
